import noop from 'utils/noop';

import { IOffersFilters, OffersServiceMode } from './types';

const initialState: IOffersFilters = {
  [OffersServiceMode.PICKUP_ONLY]: false,
  [OffersServiceMode.DELIVERY_ONLY]: false,
  inStoreEnabled: false,
};

// TODO REMOVE
export const useLoyaltyOffersFilters = () => {
  return {
    appliedFilters: initialState,
    toggleFilter: noop,
  };
};
